import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/tmp/build_163e7334/layouts/default.vue").then(m => m.default || m)),
  login: defineAsyncComponent(() => import("/tmp/build_163e7334/layouts/login.vue").then(m => m.default || m))
}